/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalInfo = {
  properties: {
    id: {
      type: 'string',
    },
    uuid: {
      type: 'string',
    },
    profession: {
      type: 'string',
      isRequired: true,
    },
    professionId: {
      type: 'string',
    },
    status: {
      type: 'string',
      isRequired: true,
    },
    register: {
      type: 'ProfessionalRegister',
    },
    documents: {
      type: 'array',
      contains: {
        type: 'ProfessionalDocument',
      },
    },
    extraSpecialties: {
      type: 'array',
      contains: {
        type: 'DoctorExtraSpecialty',
      },
    },
    digitalCertificate: {
      type: 'ProfessionalDigitalCertificate',
    },
    board: {
      type: 'Board',
    },
  },
} as const;
